import types from "./types";
import axios from "@/helpers/axios";
import invoiceCode from "@/helpers/algo/invoiceCode";

export default {
  [types.ORDER_SET_BY_INDEX]: ({ commit }, payload) => {
    commit(types.ORDER_SET_BY_INDEX, payload);
  },
  [types.ORDER_ADD_SCHEDULE]: ({ commit }, payload) => {
    commit(types.ORDER_ADD_SCHEDULE, payload);
  },
  [types.ORDER_REMOVE_SCHEDULE]: ({ commit }, payload) => {
    commit(types.ORDER_REMOVE_SCHEDULE, payload);
  },
  [types.ORDER_SET]: ({ commit }, payload) => {
    commit(types.ORDER_SET, payload);
  },
  [types.ORDER_CLEAR]: ({ dispatch }) => {
    dispatch(types.ORDER_SET, []);
    localStorage.removeItem("orders");
  },
  [types.ORDER_ADD_INVOICE_CODE]: ({ dispatch }, payload) => {
    const code = invoiceCode(payload);
    axios.patch(`/orders/${payload}`, { code }).then(() => {
      dispatch(types.ORDER_CLEAR);
    });
  },
  [types.ORDER_SET_CURRENT_USER]: ({ commit }, payload) => {
    commit(types.ORDER_SET_CURRENT_USER, payload);
  },
  [types.FETCH_CATEGORY_PAGINATE]: async ({ commit, state }, action) => {
    const { page, hasNextPage } = state.categoryMeta;
    if (hasNextPage) {
      return await axios
        .get(
          `/categories?page[number]=${page}&page[size]=10&fields=id,name,-Products&${action}`
        )
        .then(response => {
          const { data, meta } = response.data;
          if (data && meta) {
            commit(types.FETCH_CATEGORY_PAGINATE, { data, meta });
          }
        });
    }
  },
  [types.CATEGORY_LIST_RESET]: ({ commit }) => {
    commit(types.CATEGORY_LIST_RESET);
  },
  [types.FETCH_LOCATION_PAGINATE]: async ({ commit, state }, action) => {
    const { page, hasNextPage } = state.locationMeta;
    if (hasNextPage) {
      return await axios
        .get(`/locations?page[number]=${page}&page[size]=10&${action}`)
        .then(response => {
          const { data, meta } = response.data;
          if (data && meta) {
            commit(types.FETCH_LOCATION_PAGINATE, { data, meta });
          }
        });
    }
  },
  [types.LOCATION_LIST_RESET]: ({ commit }) => {
    commit(types.LOCATION_LIST_RESET);
  },
  [types.SET_INVALID_ORDER]: ({ commit }, payload) => {
    commit(types.SET_INVALID_ORDER, payload);
  }
};
